import ORDER from 'constants/order.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import alwaysZero from 'utils/functions/nullary/alwaysZero.util';
import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';
import parseDate from 'utils/parsers/parseDate';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';

const DEFAULT_ORDER = ORDER.asc;

const byDate = withOptions(({ key, order }) => {
  const ord = isEnumVal(ORDER, order) ? order : DEFAULT_ORDER;
  const k = fromAnyToTrimmed(key); // NOTE: Symbols not currently supported

  if (!k) {
    return alwaysZero;
  }

  return (a, b) => {
    const valA = asObject(a)[key];
    const valB = asObject(b)[key];

    const dateA = parseDate(valA);
    const dateB = parseDate(valB);

    // eslint-disable-next-line no-nested-ternary
    const diff = dateA < dateB ? -1 : dateB < dateA ? 1 : 0;

    // prevents from getting -0 which will fail the test pointlessly since Object.is(-0,+0) returns false
    if (diff === 0) return 0;

    return ord === ORDER.asc ? diff : -1 * diff;
  };
});
// noinspection JSUnusedGlobalSymbols
export default byDate;
